import "./../styles.scss";

import React, { useRef } from "react";
import { Line } from "react-chartjs-2";

const LineChart = (props) => {
  const { chartData, inDrawer, timePeriod = 1, initialLoad = false, targetIndex = -1, zoom = false } = props;
  const chartRef = useRef(null);
  const customCanvasBackgroundColor = {
    id: "customCanvasBackgroundColor",
    beforeDraw: (chart, args, options) => {
      const { ctx } = chart;
      ctx.save();
      ctx.globalCompositeOperation = "destination-over";
      ctx.fillStyle = options.color || "#99ffff";
      ctx.fillRect(0, 0, chart.width, chart.height);
      ctx.restore();
    },
  };
  //generate custom tooltip to point the timestamp selected by user
  const defaultLoadTooltipPlugin = {
    id: "defaultLoadTooltipPlugin",
    afterDraw(chart, _args, options) {
      const { ctx } = chart;
      const { targetIndex, initialLoad } = options;
      ctx.save();
      chart.data.datasets.forEach((_dataset, i) => {
        chart.getDatasetMeta(i).data.forEach((datapoint, index) => {
          const { x, y } = datapoint.tooltipPosition();
          const text = `${chart.data.labels[index]}, ${chart.data.datasets[i].data[index]}`;
          ctx.font = "15px Arial";
          const textWidth = ctx.measureText(text).width;
          const { right } = chart.chartArea;
          const lastDifference = right - (x + (textWidth + 10) / 2);
          const startX =
            lastDifference < 0
              ? Math.max(x - (textWidth + 10) / 2, 0) + lastDifference
              : Math.max(x - (textWidth + 10) / 2, 0);
          const endX = textWidth + 10;
          if (targetIndex !== -1 && targetIndex === index && initialLoad) {
            if (y - 125 <= 0) {
              ctx.fillRect(startX, y + 125, endX, 20);
              ctx.fillStyle = "rgba(0.0,0,0.8)";
              //triangle
              ctx.beginPath();
              ctx.moveTo(x, y + 105);
              ctx.lineTo(x - 10, y + 115);
              ctx.lineTo(x + 10, y + 115);
              ctx.fill();
              //text
              ctx.fillStyle = "white";
              ctx.fillText(text, startX, y + 135);
            } else {
              ctx.fillRect(startX, y - 125, endX, 20);
              ctx.fillStyle = "rgba(0.0,0,0.8)";
              //triangle
              ctx.beginPath();
              ctx.moveTo(x, y - 85);
              ctx.lineTo(x - 10, y - 95);
              ctx.lineTo(x + 10, y - 95);
              ctx.fill();
              //text
              ctx.fillStyle = "white";
              ctx.fillText(text, startX, y - 115);
            }
          }
        });
      });
      ctx.restore();
    },
  };

  const options = {
    plugins: {
      customCanvasBackgroundColor: {
        color: "white",
      },
      defaultLoadTooltipPlugin: {
        targetIndex: targetIndex,
        initialLoad: initialLoad,
      },
      legend: {
        display: !inDrawer,
        onClick: () => {
          return;
        },
        labels: {
          color: "black",
        },
      },
      tooltip: {
        titleFont: { size: 18 },
        bodyFont: { size: 15 },
        callbacks: {
          label: function (context) {
            return context.formattedValue;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: zoom,
          text: "Time",
          color: "black",
          font: {
            size: 14,
            weight: "bold",
          },
        },
        grid: {
          display: !inDrawer,
        },
        ticks: {
          color: "black",
          maxTicksLimit: 10,
          // custom X axis label based on timeperiod selected by user
          callback: function (index) {
            if (zoom) return chartData.labels[index];
            const label =
              timePeriod > 24
                ? chartData.labels[index].split(" ")[0].split("-").slice(0, -1).join("/")
                : chartData.labels[index].split(" ")[1];
            return label;
          },
        },
        display: !inDrawer,
      },
      y: {
        ticks: { color: "black" },
        beginAtZero: true,
        title: {
          display: zoom,
          text: chartData.datasets[0].label,
          color: "black",
          font: {
            size: 14,
            weight: "bold",
          },
        },
        grid: {
          display: false,
        },
        display: !inDrawer,
      },
    },
  };
  return (
    <Line
      ref={chartRef}
      data={chartData}
      options={options}
      redraw={initialLoad}
      plugins={[customCanvasBackgroundColor, defaultLoadTooltipPlugin]}
    />
  );
};
export default LineChart;
